// import React, { useEffect, useMemo, useState } from 'react';
// import {
//   Card,
//   CardBody,
//   Row,
//   Col,
//   Label,
//   Input,
//   Table,
//   Spinner,
//   Alert,
//   Button,
// } from 'reactstrap';
// import { useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import { toast } from 'react-toastify';

// import useVendorBranch from '../../utils/useVendorBranch';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';
// import VendorBranchSelector from '../../components/VendorBranchSelector';

// const EmployeeAttendanceReportPage = () => {
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.authState);

//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const todayStr = useMemo(() => new Date().toISOString().split('T')[0], []);

//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });

//   const [errorMessage, setErrorMessage] = useState({});
//   const [search, setSearch] = useState('');
//   const [fromDate, setFromDate] = useState(todayStr);
//   const [toDate, setToDate] = useState(todayStr);

//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [summary, setSummary] = useState({
//     totalEmployees: 0,
//     totalWorkingDays: 0,
//     totalPresentDays: 0,
//     totalAbsentDays: 0,
//     avgPercentage: 0,
//   });

//   const fetchReport = async (searchText = search) => {
//     try {
//       setLoading(true);
//       setError('');

//       if (!fromDate || !toDate) {
//         setError('Please select from date and to date.');
//         setRows([]);
//         return;
//       }

//       if (fromDate > toDate) {
//         setError('From date cannot be greater than to date.');
//         setRows([]);
//         return;
//       }

//       const vendorId = selectionData.vendor_id || '';
//       const branchId = selectionData.branch_id || '';

//       const response = await apiService.get(
//         `api/AttendanceMaster/employee-report?fromDate=${fromDate}&toDate=${toDate}&vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(searchText || '')}`,
//       );

//       if (response.status === true) {
//         const list = response.data || [];
//         setRows(list);

//         const totalEmployees = list.length;
//         const totalWorkingDays =
//           totalEmployees > 0 ? Number(list[0]?.totalWorkingDays || 0) : 0;

//         const totalPresentDays = list.reduce(
//           (sum, item) => sum + Number(item.presentDays || 0),
//           0,
//         );

//         const totalAbsentDays = list.reduce(
//           (sum, item) => sum + Number(item.absentDays || 0),
//           0,
//         );

//         const avgPercentage =
//           totalEmployees > 0
//             ? (
//                 list.reduce(
//                   (sum, item) => sum + Number(item.attendancePercentage || 0),
//                   0,
//                 ) / totalEmployees
//               ).toFixed(2)
//             : 0;

//         setSummary({
//           totalEmployees,
//           totalWorkingDays,
//           totalPresentDays,
//           totalAbsentDays,
//           avgPercentage,
//         });
//       } else {
//         setRows([]);
//         setSummary({
//           totalEmployees: 0,
//           totalWorkingDays: 0,
//           totalPresentDays: 0,
//           totalAbsentDays: 0,
//           avgPercentage: 0,
//         });
//         toast.error(response.message || 'Unable to load report');
//       }
//     } catch (err) {
//       console.log(err);
//       setRows([]);
//       setSummary({
//         totalEmployees: 0,
//         totalWorkingDays: 0,
//         totalPresentDays: 0,
//         totalAbsentDays: 0,
//         avgPercentage: 0,
//       });
//       toast.error('Something went wrong while loading report!');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: selectionData.vendor_id,
//       branchId: selectionData.branch_id,
//     });

//     if (canLoad && fromDate && toDate) {
//       fetchReport();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [selectionData.vendor_id, selectionData.branch_id, fromDate, toDate]);

//   const handleSearch = (e) => {
//     const val = e.target.value;
//     setSearch(val);
//     fetchReport(val);
//   };

//   return (
//     <div className='container-fluid mt-3'>
//       <Row className='mb-2 align-items-end'>
//         <Col md='8'>
//           <h5 className='mb-1'>Employee Attendance Report</h5>
//         </Col>
//         <Col md='4' className='text-right'>
//           <Button color='secondary' size='sm' onClick={() => navigate(-1)}>
//             « Back
//           </Button>
//         </Col>
//       </Row>

//       <VendorBranchSelector
//         user={user}
//         selectionData={selectionData}
//         setSelectionData={setSelectionData}
//         errorMessage={errorMessage}
//         accessButton={true}
//       />

//       <Card className='card-box height-100-p pd-20 mb-20'>
//         <CardBody>
//           <Row className='mb-3'>
//             <Col md='4'>
//               <Label>Search</Label>
//               <Input
//                 placeholder='Search by employee code / name / designation'
//                 value={search}
//                 onChange={handleSearch}
//               />
//             </Col>

//             <Col md='4'>
//               <Label>From Date</Label>
//               <Input
//                 type='date'
//                 value={fromDate}
//                 max={todayStr}
//                 onChange={(e) => setFromDate(e.target.value)}
//               />
//             </Col>

//             <Col md='4'>
//               <Label>To Date</Label>
//               <Input
//                 type='date'
//                 value={toDate}
//                 max={todayStr}
//                 onChange={(e) => setToDate(e.target.value)}
//               />
//             </Col>

//             {/* <Col md='3' className='d-flex align-items-end'>
//               <Button
//                 color='primary'
//                 className='w-100'
//                 onClick={() => fetchReport()}
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <Spinner size='sm' className='mr-2' /> Loading...
//                   </>
//                 ) : (
//                   'Get Report'
//                 )}
//               </Button>
//             </Col> */}
//           </Row>

//           {error && <Alert color='danger'>{error}</Alert>}

//           <Row className='mb-3'>
//             <Col md='3'>
//               <Card body className='text-center shadow-sm'>
//                 <h6>Total Employees</h6>
//                 <h4>{summary.totalEmployees}</h4>
//               </Card>
//             </Col>

//             <Col md='3'>
//               <Card body className='text-center shadow-sm'>
//                 <h6>Working Days</h6>
//                 <h4>{summary.totalWorkingDays}</h4>
//               </Card>
//             </Col>

//             <Col md='3'>
//               <Card body className='text-center shadow-sm'>
//                 <h6>Total Present Days</h6>
//                 <h4>{summary.totalPresentDays}</h4>
//               </Card>
//             </Col>

//             <Col md='3'>
//               <Card body className='text-center shadow-sm'>
//                 <h6>Total Absent Days</h6>
//                 <h4>{summary.totalAbsentDays}</h4>
//               </Card>
//             </Col>
//           </Row>

//           <Row className='mb-3'>
//             <Col md='12'>
//               <Alert color='info' className='mb-0'>
//                 <strong>Average Attendance %:</strong> {summary.avgPercentage}%
//               </Alert>
//             </Col>
//           </Row>

//           {loading ? (
//             <div className='text-center py-4'>
//               <Spinner /> Loading report...
//             </div>
//           ) : (
//             <div className='table-responsive'>
//               <Table striped hover bordered size='sm'>
//                 <thead>
//                   <tr>
//                     <th style={{ width: '60px' }}>#</th>
//                     <th>Employee Code</th>
//                     <th>Employee Name</th>
//                     <th>Designation</th>
//                     <th>Total Working Days</th>
//                     <th>Present Days</th>
//                     <th>Absent Days</th>
//                     <th>Attendance %</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {rows.length > 0 ? (
//                     rows.map((item, index) => (
//                       <tr key={item.employeeId ?? index}>
//                         <td>{index + 1}</td>
//                         <td>{item.employeeCode ?? '-'}</td>
//                         <td>{item.employeeName ?? '-'}</td>
//                         <td>{item.designationName ?? '-'}</td>
//                         <td>{item.totalWorkingDays ?? 0}</td>
//                         <td>{item.presentDays ?? 0}</td>
//                         <td>{item.absentDays ?? 0}</td>
//                         <td>
//                           <strong>{item.attendancePercentage ?? 0}%</strong>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan='8' className='text-center'>
//                         No report data found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </Table>
//             </div>
//           )}
//         </CardBody>
//       </Card>
//     </div>
//   );
// };

// export default EmployeeAttendanceReportPage;
//
import React, { useEffect, useMemo, useState } from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Label,
  Input,
  Table,
  Spinner,
  Alert,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';

import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import VendorBranchSelector from '../../components/VendorBranchSelector';

const EmployeeAttendanceReportPage = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const todayStr = useMemo(() => new Date().toISOString().split('T')[0], []);

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const [errorMessage, setErrorMessage] = useState({});
  const [search, setSearch] = useState('');
  const [fromDate, setFromDate] = useState(todayStr);
  const [toDate, setToDate] = useState(todayStr);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [summary, setSummary] = useState({
    totalEmployees: 0,
    totalWorkingDays: 0,
    totalPresentDisplay: 0,
    totalAbsentDisplay: 0,
    presentLabel: 'Total Present Employee',
    absentLabel: 'Total Absent Employee',
    avgPercentage: 0,
    totalMonthlySalary: 0,
    totalInHandSalary: 0,
  });

  const [salaryModal, setSalaryModal] = useState(false);
  const [selectedSalaryRow, setSelectedSalaryRow] = useState(null);

  const isSingleDayFilter = fromDate && toDate && fromDate === toDate;

  const resetSummary = () => {
    setSummary({
      totalEmployees: 0,
      totalWorkingDays: 0,
      totalPresentDisplay: 0,
      totalAbsentDisplay: 0,
      presentLabel:
        fromDate === toDate ? 'Total Present Employee' : 'Average Present Days',
      absentLabel: fromDate === toDate ? 'Total Absent Employee' : '',
      avgPercentage: 0,
      totalMonthlySalary: 0,
      totalInHandSalary: 0,
    });
  };

  const fetchReport = async (searchText = search) => {
    try {
      setLoading(true);
      setError('');

      if (!fromDate || !toDate) {
        setError('Please select from date and to date.');
        setRows([]);
        resetSummary();
        return;
      }

      if (fromDate > toDate) {
        setError('From date cannot be greater than to date.');
        setRows([]);
        resetSummary();
        return;
      }

      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const response = await apiService.get(
        `api/AttendanceMaster/employee-report?fromDate=${fromDate}&toDate=${toDate}&vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (response.status === true) {
        const list = response.data || [];
        setRows(list);

        const totalEmployees = list.length;

        const totalWorkingDays =
          totalEmployees > 0 ? Number(list[0]?.totalWorkingDays || 0) : 0;

        const totalPresentDaysSum = list.reduce(
          (sum, item) => sum + Number(item.presentDays || 0),
          0,
        );

        const totalMonthlySalary = list.reduce(
          (sum, item) => sum + Number(item.salaryAmount || 0),
          0,
        );

        const totalInHandSalary = list.reduce(
          (sum, item) => sum + Number(item.inHandSalary || 0),
          0,
        );

        const avgPercentage =
          totalEmployees > 0
            ? (
                list.reduce(
                  (sum, item) => sum + Number(item.attendancePercentage || 0),
                  0,
                ) / totalEmployees
              ).toFixed(2)
            : 0;

        let totalPresentDisplay = 0;
        let totalAbsentDisplay = 0;
        let presentLabel = 'Average Present Days';
        let absentLabel = '';

        if (fromDate === toDate) {
          totalPresentDisplay = list.filter(
            (item) => Number(item.presentDays || 0) > 0,
          ).length;

          totalAbsentDisplay = list.filter(
            (item) => Number(item.absentDays || 0) > 0,
          ).length;

          presentLabel = 'Total Present Employee';
          absentLabel = 'Total Absent Employee';
        } else {
          totalPresentDisplay =
            totalEmployees > 0
              ? (totalPresentDaysSum / totalEmployees).toFixed(2)
              : 0;

          totalAbsentDisplay = 0;
          presentLabel = 'Average Present Days';
          absentLabel = '';
        }

        setSummary({
          totalEmployees,
          totalWorkingDays,
          totalPresentDisplay,
          totalAbsentDisplay,
          presentLabel,
          absentLabel,
          avgPercentage,
          totalMonthlySalary: totalMonthlySalary.toFixed(2),
          totalInHandSalary: totalInHandSalary.toFixed(2),
        });
      } else {
        setRows([]);
        resetSummary();
        toast.error(response.message || 'Unable to load report');
      }
    } catch (err) {
      console.log(err);
      setRows([]);
      resetSummary();
      toast.error('Something went wrong while loading report!');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad && fromDate && toDate) {
      fetchReport();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionData.vendor_id, selectionData.branch_id, fromDate, toDate]);

  const handleSearch = (e) => {
    const val = e.target.value;
    setSearch(val);
    fetchReport(val);
  };

  const openSalaryModal = (row) => {
    setSelectedSalaryRow(row);
    setSalaryModal(true);
  };

  const closeSalaryModal = () => {
    setSalaryModal(false);
    setSelectedSalaryRow(null);
  };

  return (
    <div className='container-fluid mt-3'>
      <Row className='mb-2 align-items-end'>
        <Col md='8'>
          <h5 className='mb-1'>Employee Attendance Salary Report</h5>
        </Col>

        <Col md='4' className='text-right'>
          <Button color='secondary' size='sm' onClick={() => navigate(-1)}>
            « Back
          </Button>
        </Col>
      </Row>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardBody>
          <Row className='mb-3'>
            <Col md='4'>
              <Label>Search</Label>
              <Input
                placeholder='Search by employee code / name / designation'
                value={search}
                onChange={handleSearch}
              />
            </Col>

            <Col md='4'>
              <Label>From Date</Label>
              <Input
                type='date'
                value={fromDate}
                max={todayStr}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Col>

            <Col md='4'>
              <Label>To Date</Label>
              <Input
                type='date'
                value={toDate}
                max={todayStr}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Col>
          </Row>

          {error && <Alert color='danger'>{error}</Alert>}

          <Row className='mb-3'>
            <Col md={isSingleDayFilter ? '3' : '4'}>
              <Card body className='text-center shadow-sm'>
                <h6>Total Employees</h6>
                <h4>{summary.totalEmployees}</h4>
              </Card>
            </Col>

            <Col md={isSingleDayFilter ? '3' : '4'}>
              <Card body className='text-center shadow-sm'>
                <h6>Working Days</h6>
                <h4>{summary.totalWorkingDays}</h4>
              </Card>
            </Col>

            <Col md={isSingleDayFilter ? '3' : '4'}>
              <Card body className='text-center shadow-sm'>
                <h6>{summary.presentLabel}</h6>
                <h4>{summary.totalPresentDisplay}</h4>
              </Card>
            </Col>

            {isSingleDayFilter && (
              <Col md='3'>
                <Card body className='text-center shadow-sm'>
                  <h6>{summary.absentLabel}</h6>
                  <h4>{summary.totalAbsentDisplay}</h4>
                </Card>
              </Col>
            )}
          </Row>

          {loading ? (
            <div className='text-center py-4'>
              <Spinner /> Loading report...
            </div>
          ) : (
            <div className='table-responsive'>
              <Table striped hover bordered size='sm'>
                <thead>
                  <tr>
                    <th style={{ width: '60px' }}>#</th>
                    <th>Employee Name</th>
                    <th>Designation</th>
                    <th>Total Working Days</th>
                    <th>Present Days</th>
                    <th>Absent Days</th>
                    <th>Leaves Allowed</th>
                    <th>Leaves Used</th>
                    <th>Remaining Leaves</th>
                    <th>Deduction Days</th>
                    <th style={{ width: '140px' }}>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {rows.length > 0 ? (
                    rows.map((item, index) => (
                      <tr key={item.employeeId ?? index}>
                        <td>{index + 1}</td>
                        <td>{item.employeeName ?? '-'}</td>
                        <td>{item.designationName ?? '-'}</td>
                        <td>{item.totalWorkingDays ?? 0}</td>
                        <td>{item.presentDays ?? 0}</td>
                        <td>{item.absentDays ?? 0}</td>
                        <td>{item.allowedLeaveDays ?? 0}</td>
                        <td>{item.paidLeaveUsed ?? 0}</td>
                        <td>{item.remainingLeaveDays ?? 0}</td>
                        <td>{item.deductionDays ?? 0}</td>

                        <td>
                          <Button
                            color='primary'
                            size='sm'
                            onClick={() => openSalaryModal(item)}
                          >
                            Salary View
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan='11' className='text-center'>
                        No report data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </CardBody>
      </Card>

      <Modal isOpen={salaryModal} toggle={closeSalaryModal} centered>
        <ModalHeader toggle={closeSalaryModal}>Salary Calculation</ModalHeader>

        <ModalBody>
          {selectedSalaryRow && (
            <div>
              <p className='mb-2'>
                <strong>Employee:</strong>{' '}
                {selectedSalaryRow.employeeName || '-'}
              </p>

              <p className='mb-2'>
                <strong>Designation:</strong>{' '}
                {selectedSalaryRow.designationName || '-'}
              </p>

              <hr />

              <p className='mb-2'>
                <strong>Total Working Days:</strong>{' '}
                {selectedSalaryRow.totalWorkingDays ?? 0}
              </p>

              <p className='mb-2'>
                <strong>Present Days:</strong>{' '}
                {selectedSalaryRow.presentDays ?? 0}
              </p>

              <p className='mb-2'>
                <strong>Absent Days:</strong>{' '}
                {selectedSalaryRow.absentDays ?? 0}
              </p>

              <p className='mb-2'>
                <strong>Attendance %:</strong>{' '}
                {selectedSalaryRow.attendancePercentage ?? 0}%
              </p>

              <hr />

              <p className='mb-2'>
                <strong>Leaves Allowed:</strong>{' '}
                {selectedSalaryRow.allowedLeaveDays ?? 0}
              </p>

              <p className='mb-2'>
                <strong>Leaves Used:</strong>{' '}
                {selectedSalaryRow.paidLeaveUsed ?? 0}
              </p>

              <p className='mb-2'>
                <strong>Remaining Leaves:</strong>{' '}
                {selectedSalaryRow.remainingLeaveDays ?? 0}
              </p>

              <p className='mb-2'>
                <strong>Deduction Days:</strong>{' '}
                {selectedSalaryRow.deductionDays ?? 0}
              </p>

              <hr />

              <p className='mb-2'>
                <strong>Monthly Salary:</strong>{' '}
                {Number(selectedSalaryRow.salaryAmount ?? 0).toFixed(2)}
              </p>

              <p className='mb-2'>
                <strong>Per Day Salary:</strong>{' '}
                {Number(selectedSalaryRow.perDaySalary ?? 0).toFixed(2)}
              </p>

              <p className='mb-2'>
                <strong>Deduction Amount:</strong>{' '}
                {Number(selectedSalaryRow.deductionAmount ?? 0).toFixed(2)}
              </p>

              <hr />

              <h5 className='mb-0'>
                <strong>In Hand Salary:</strong>{' '}
                {Number(selectedSalaryRow.inHandSalary ?? 0).toFixed(2)}
              </h5>
            </div>
          )}
        </ModalBody>

        <ModalFooter>
          <Button color='secondary' onClick={closeSalaryModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default EmployeeAttendanceReportPage;
